import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Carousel({ slides }) {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Change slide every 5 seconds
    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const slide = slides[currentSlide];

  return (
    <section className="carousel-section hero-section">
      <div className="carousel-container">
        <div className="carousel-content hero-copy">
          <p>Welcome to Goal Path HR Solution</p>
          <h1>{slide.title}</h1>
          <p className="hero-subtitle">{slide.subtitle}</p>
          <div className="hero-actions">
            <Link to="/contact" className="btn btn-primary">
              {slide.primaryLabel}
            </Link>
            <a href="/service" className="btn btn-secondary">
              {slide.secondaryLabel}
            </a>
          </div>
        </div>

        {/* Carousel Controls */}
        <div className="carousel-controls">
          <button className="carousel-btn prev-btn" onClick={prevSlide}>
            &#10094;
          </button>
          <button className="carousel-btn next-btn" onClick={nextSlide}>
            &#10095;
          </button>
        </div>

        {/* Carousel Indicators */}
        <div className="carousel-indicators">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Carousel;
